import { routerStyxie } from '@/router/styxieBridge'
import { useLsaCommonStore } from '@/stores/lsa/common'

Styxie.Initializers.LsaDashboard = routerStyxie({
  actions: ['index'],
  hydrate: (props, pinia) => useLsaCommonStore(pinia).initialize(props)
})
